import {Group, Table, TableTdProps} from '@mantine/core';
import classes from '../job-details.module.css';
import {EvaluationDetailDto} from '../../api/generated/index.defs';
import React, {FC} from 'react';
import {DateTime} from 'luxon';
import {formatJSDate} from '../../utils/luxon';

const TableLabel = React.memo(
  ({children, ...rest}: {children?: React.ReactNode} & TableTdProps) => (
    <Table.Td w={275} {...rest}>
      {children}
    </Table.Td>
  ),
);

const TableData = React.memo(
  ({children, ...rest}: {children?: React.ReactNode} & TableTdProps) => (
    <Table.Td fw='600' {...rest}>
      {children}
    </Table.Td>
  ),
);

type JobDetailsProps = {
  evaluation: EvaluationDetailDto | null | undefined;
};

export const JobEvaluationDetails: FC<JobDetailsProps> = ({evaluation}) => {
  return (
    <Table withColumnBorders>
      <Table.Thead>
        <Table.Tr>
          <Table.Th fw='normal' colSpan={4} className={classes.tableHeader}>
            Job Evaluation
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        <Table.Tr>
          <TableLabel>Evaluation Complete Date</TableLabel>
          <TableData>
            <Group gap={6}>
              {evaluation?.completedDate
                ? formatJSDate(evaluation.completedDate, DateTime.DATE_SHORT)
                : 'N/A'}
            </Group>
          </TableData>

          <TableLabel>Job Quoted Date</TableLabel>
          <TableData>
            {evaluation?.quotedDate
              ? formatJSDate(evaluation.quotedDate, DateTime.DATE_SHORT)
              : 'N/A'}
          </TableData>
        </Table.Tr>
        <Table.Tr>
          <TableLabel>Email Evaluation Form Status</TableLabel>
          <TableData>
            <Group>
              {evaluation?.wasEvaluationFormSent ? 'Sent \t' : 'Not Sent'}
              {evaluation?.sentDate &&
                formatJSDate(evaluation.sentDate, DateTime.DATE_SHORT)}
            </Group>
          </TableData>

          <TableLabel>Quote Approved/Disapproved Date</TableLabel>
          <TableData>
            <Group gap={6}>
              {evaluation?.quoteApprovedDisapprovedDate
                ? formatJSDate(
                    evaluation.quoteApprovedDisapprovedDate,
                    DateTime.DATE_SHORT,
                  )
                : 'N/A'}
            </Group>
          </TableData>
        </Table.Tr>
      </Table.Tbody>
    </Table>
  );
};
